//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'AcrEular',
  data () {
    return {
      form: {
        affectedJoints: '',
        serological: '',
        synovitis: '',
        acute: '',
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '1个中大关节ᵃ'},
        {value: '1', name: '2~10个中大关节'},
        {value: '2', name: '1~3个小关节ᵇ'},
        {value: '3', name: '4~10个小关节'},
        {value: '5', name: '＞10个关节（至少1个小关节）'}
      ],
      dataList2: [
        {value: '0', name: 'RF和抗CCP抗体均（-）'},
        {value: '2', name: 'RF或抗CCP抗体低效价（+）'},
        {value: '3', name: 'RF或抗CCP抗体高效价（正常上限3倍）'}
      ],
      dataList3: [
        {value: '0', name: '＜6周'},
        {value: '1', name: '≥6周'}
      ],
      dataList4: [
        {value: '0', name: 'CRP和ESR均正常'},
        {value: '1', name: 'CRP或ESR升高'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/AcrEular.vue